function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDesktopRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6h20v2h2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h9v2H8v2h10v-2h-3v-2h3v-6H4V6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 14h6v-2h-6v2zm0 4h6v-2h-6v2zm6-8h-6a2 2 0 00-2 2v16h10V12a2 2 0 00-2-2z",
    fill: props.color
  }));
}

export default SvgIconDesktopRexFilled;